export type MachineKind = 'washer' | 'dryer' | 'unknown';

export type CycleTemperature = {
  id: string;
  name?: string;
  isDefault?: boolean;
};

export type CycleCatalogItem = {
  id: string;
  name?: string;
  temperatures?: CycleTemperature[];
};

export type GetPriceResult = {
  kind?: MachineKind;
  pricing?: {
    selectedCycle?: { id?: string; name?: string } | null;
    allianceStatus?: string | null;
  };
  cycles?: {
    isCycleSelectionSupported?: boolean;
    cycles?: CycleCatalogItem[];
  } | null;
};

export const DRYER_MINUTE_OPTIONS = [15, 30, 45, 60] as const;
export const DEFAULT_WASHER_TEMP_ID = 'temp_cold';

export function machineKindFromName(name: string): MachineKind {
  const prefix = String(name || '').charAt(0).toUpperCase();
  if (prefix === 'W') return 'washer';
  if (prefix === 'D') return 'dryer';
  return 'unknown';
}

export function cycleLabel(name: string | undefined, id: string): string {
  const n = (name || '').trim();
  return n || id;
}

export function filterCycleCatalog(
  cycles: CycleCatalogItem[] | undefined
): CycleCatalogItem[] {
  return (cycles || []).filter((c) => !!c?.id);
}

export function defaultTemperatureId(cycle: CycleCatalogItem | undefined): string | null {
  if (!cycle?.temperatures?.length) return DEFAULT_WASHER_TEMP_ID;
  const preferred =
    cycle.temperatures.find((t) => t.id === DEFAULT_WASHER_TEMP_ID) ||
    cycle.temperatures.find((t) => t.isDefault) ||
    cycle.temperatures[0];
  return preferred?.id || DEFAULT_WASHER_TEMP_ID;
}

export function axiosErrorMessage(err: unknown, fallback: string): string {
  const axiosErr = err as {
    response?: { data?: { message?: string; error?: string } };
    message?: string;
  };
  return (
    axiosErr?.response?.data?.message ||
    axiosErr?.response?.data?.error ||
    axiosErr?.message ||
    fallback
  );
}
